module.exports = __webpack_public_path__ + "static/media/sidebar-button-highlighted.e928fb49.png";